// const BaseUrl2 = "https://gokulnair.com/levelup_backend/api/";
const BaseUrl = "https://panel.whitelabelmd.com/ageshiftrx/api/";
const BaseUrl2 = "https://panel.whitelabelmd.com/ageshiftrx_v2/api";
// "https://lightgoldenrodyellow-okapi-586794.hostingersite.com/ageshiftrx/api/";

export const products_url = BaseUrl + "get_products";
export const cheke_state = BaseUrl + "cheke_state";
export const cheke_state_v2 = BaseUrl2 + "/cheke_state";
export const add_user_check_product = BaseUrl + "createOrder_test2";
export const contact_details_step_25 = BaseUrl + "contact_details_step_25";
export const get_product_details = BaseUrl + "get_product_details2";
export const get_product_details_v2 = BaseUrl2 + "/get_product_details2";
export const get_url_data = BaseUrl + "get_url_data";
export const get_url_data_v2 = BaseUrl2 + "/get_url_data";
export const createOrder_test = BaseUrl + "createOrder_test2";
export const createOrder_test_v2 = BaseUrl2 + "/createOrder_test2";
export const check_coupons = BaseUrl + "check_coupons2";
export const check_coupons_v2 = BaseUrl2 + "/check_coupons2";
export const member_view = BaseUrl + "member_view";
export const member_view_v2 = BaseUrl2 + "/member_view";